@if (screenInfo$ | async; as screen) {
  <div style="display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
          <sh-tabs id="escalations-tabs-1" style="width: 60%" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
            >
            @for (tab of displayedTabs; track tab.name) {
              <sh-tab-item id="escalations-tab-item-2" disabled [active]="activeTab === tab.name"
              (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            }
          </sh-tabs>
        }
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="escalations-spinner-3" site="s"></sh-spinner>
        </div>
      </div>
    }
    @if (!isLoading && escalations) {
      <div style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="escalations" [scrollable]="true" scrollHeight="flex"
          [customSort]="true" (sortFunction)="customSort($event)" [sortField]="'opened'" [sortOrder]="1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 8px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="escalations-tabs-4" style="flex: 1 1 60%;" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="escalations-tab-item-5" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 40%; gap: 8px; align-items: center;">
                <sh-dropdown id="escalations-dropdown-6" no-border condensed style="min-width: 100px; max-width: 140px;">
                  <sh-menu-item id="escalations-menu-item-last-30-days" (click)="changeRange(30,'serviceHistory')" [attr.label]="'msNotifications.range.last30Days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                  <sh-menu-item id="escalations-menu-item-last-60-days" (click)="changeRange(60,'serviceHistory')" [attr.label]="'msNotifications.range.last60Days' | transloco"
                  [active]="selectedRange === 60"></sh-menu-item>
                  <sh-menu-item id="escalations-menu-item-last-90-days" (click)="changeRange(90,'serviceHistory')" [attr.label]="'msNotifications.range.last90Days' | transloco"
                  [active]="selectedRange === 90"></sh-menu-item>
                  <sh-menu-item id="escalations-menu-item-last-120-days" (click)="changeRange(120,'serviceHistory')" [attr.label]="'msNotifications.range.last120Days' | transloco"
                  [active]="selectedRange === 120"></sh-menu-item>
                </sh-dropdown>
                <p-columnFilter style="flex: 0 1 210px;" type="text" [showMenu]="false" field="description"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="escalations-search-search-for-issue" no-border [attr.label]="'escalations.filter.searchForIssue' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="escalations-divider-12" spacing='s' style="height: 30px;" vertical></sh-divider>
                <sh-icon id="escalations-icon-13" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                <sh-icon id="escalations-icon-14" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                <sh-icon id="escalations-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template #header>
            <tr>
              <th pSortableColumn="peak" style="min-width:140px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.peakNumber' | transloco }}<p-sortIcon
                field="peak" /></div>
              </th>
              <th pSortableColumn="description" style="min-width:175px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.description' | transloco }}<p-sortIcon
                field="description" /></div>
              </th>
              <th pSortableColumn="lvl" style="min-width:150px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.escalationLvl' | transloco }}<p-sortIcon
                field="lvl" /></div>
              </th>
              <th pSortableColumn="opened" style="min-width:110px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.opened' | transloco }}<p-sortIcon field="opened" />
                </div>
              </th>
              <th pSortableColumn="closed" style="min-width:110px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.closed' | transloco }}<p-sortIcon field="closed" />
                </div>
              </th>
              <th pSortableColumn="noti" style="min-width:100px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'escalations.table.notification' | transloco }}<p-sortIcon
                field="noti" /></div>
              </th>
              <!-- <th style="min-width:75px;" alignFrozen="right" pFrozenColumn class="frozen">Actions</th> -->
            </tr>
          </ng-template>
          <ng-template #body let-escalation let-expanded="expanded">
            <tr>
              <td>{{escalation.peak}}</td>
              <td><span [innerHTML]="highlight(escalation.short_text)"></span></td>
              <td>{{escalation.level}}</td>
              <td>{{escalation.opened}}</td>
              <td>{{escalation.closed}}</td>
              <td>
                <a style="cursor: pointer;">{{escalation.notification}}</a>
              </td>
              <!-- <td alignFrozen="right" pFrozenColumn>
              <div style="display: flex; gap: 6px; justify-content: center; align-items: center;">
                <sh-icon id="escalations-icon-show" icon="show" size="s" button></sh-icon>
              </div>
            </td> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">
              @if (!isError) {
                <div
                  style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                  <sh-icon id="escalations-icon-warning" icon="warning" size="s"></sh-icon>
                  <span>{{ 'common.empty.noData' | transloco }}</span>
                </div>
              }
              @if (isError) {
                <div
                  style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                  <sh-icon id="escalations-icon-error" icon="error" size="s"></sh-icon>
                  <span>{{ 'common.empty.error' | transloco }}</span>
                </div>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
}